import Footer from '../../Parts/Footer/Footer';
import Header from '../../Parts/Header/Header';
import './layoutWithoutmenues.css';

function LayoutWithoutmenues(props) {
  const { children } = props;
  return (
    <div>
      <Header />
      {children}
      <Footer />
    </div>
  );
}

export default LayoutWithoutmenues;
